<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-data-table
			:headers="headers"
			:items="backgroundData"
			:expand="false"
			item-key="name"
		>
			<template #items="props">
				<tr @click="props.expanded = !props.expanded">
					<td>{{ props.item.name }}</td>
					<td class="text-right">
						{{ props.item.risk }}
					</td>
				</tr>
			</template>
			<template #expand="props">
				<v-card flat>
					<ul>
						<li
							v-for="change in props.item.data"
							:key="change"
						>
							{{ change }}
						</li>
					</ul>
				</v-card>
			</template>
		</v-data-table>
	</div>
</template>

<script>

export default {
	name: 'ClaimDataOverview',
	props: {
		backgroundData: {
			type: Array,
			required: true,
		},
	},
	data () {
		return {
			sortedChanges: [],
			headers: [
				{
					text: 'Field Name',
					align: 'left',
					sortable: true,
					value: 'name',
				},
				{
					text: 'Risk Factor',
					align: 'right',
					value: 'risk',
					sortable: true,
				},
			],
		};
	},
};
</script>
